import { useSelector } from 'react-redux'

import { Input } from '@/components/ui'
import { formatSurface } from '@/utils/formatters'
import { formatSurfaceAre } from '@/utils/formatters'
import DetailTemplate from '@/components/DetailTemplate'
import UploadForm from '@/components/ui/UploadForm'

import { useBienContext } from '../BienContext'
import { updateBien } from '../biensSlice'
import EditButtons from '../EditButtons'
import Form from './Form'

export default () => {
  const { bien, updatedSections, markSectionAsUpdated, 
    isPendingAction, closeModalCallback
  } = useBienContext()

  const errors = useSelector((state) => state.biens.requestStatus.errors)
  const isUpdating = useSelector((state) => state.biens.loadingStatus.update)

  const SECTION_ID = 'surfaces'
  const SECTION_TITLE = "Surfaces / terrain"

  const modalContent = <Form title={SECTION_TITLE} />
  
  const editButton = <EditButtons
    bienId={bien.id}
    isArchived={!!bien.archived_at}
    isPendingAction={isPendingAction}
    title="Modifier les surfaces"
  />

  // TODO voir pour mettre le bouton pour upload le fichier sans passer par le formulairIe
  return(
    <DetailTemplate
      title={SECTION_TITLE}
      sectionId={SECTION_ID}
      bodyProps={{columns: 3}}
      updatedSections={updatedSections}
      loading={false}
      isPendingAction={isPendingAction}
      editButton={editButton}
      modalContent={modalContent}
      onUpdateSuccess={markSectionAsUpdated}
      onCloseModalCallback={closeModalCallback}
    >
      <div className="space-y-4">
        <Input.Display label="Surface carrez" value={formatSurface(bien.surface_carrez)} />
        <Input.DisplayFile 
          item={bien}
          label="Attestation Carrez" title="Attestation Carrez" 
          name="surface_carrez_file"
          // uploadFormComponent={<UploadForm item={bien} 
          //   fileFieldName="surface_carrez_file"
          //   state={{
          //     errors, 
          //     isUpdating, 
          //     update: (data) => updateBien({id: bien.id, bienData: data})
          //   }}
          // />}
        />
        <Input.Display label="Surface sol" value={formatSurface(bien.surface_sol)} />
        <Input.Display label="Surface terrain" value={formatSurface(bien.surface_terrain)} />
        <Input.Display label="Surface terrain en ha" value={formatSurfaceAre(bien.surface_terrain)} />
      </div>
      <div className="space-y-4">
        <Input.Display label="Surface jardin" value={formatSurface(bien.surface_jardin)} />
        <Input.Display label="Orientation" value={bien.orientation} valueClassName="uppercase" />
        <Input.Display label="Constructible" value={bien.contructible} valueClassName="uppercase" />
      </div>
      <div className="space-y-4">
        <Input.Display label="Géorisques" value={bien.georisques} valueClassName="uppercase" />
        <Input.Display label="Vis à vis" value={bien.vis_a_vis} valueClassName="uppercase" />
      </div>

    </DetailTemplate>
  )
}